import types from "../../../actions/types";

export default Object.freeze({
  ...types,
  GET_TASK: "GET_TASK",
  SYNC_GET_TASK: "SYNC_GET_TASK",
  SYNC_TASK_DELETE: "SYNC_TASK_DELETE",
  GET_DIRECTION: "GET_DIRECTION"
});
